import { ref, computed } from 'vue'

const isOpen = ref(false)
const sectionId = ref(null)

const currentSection = computed(() => {
  if (!sectionId.value) return null
  return null
})

function openDetail(id) {
  sectionId.value = id
  isOpen.value = true
}

function closeDetail() {
  isOpen.value = false
}

export function useDetailModal() {
  return {
    isOpen,
    currentSection,
    openDetail,
    closeDetail,
  }
}
